import {
  Container,
  NavTableCell,
  Page,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery, useTRPC } from "../../../_app/api";
import { useTranslation } from "../../../_app/i18n";
import { translations } from "../../../companies/offenlegung/translations";

export const Route = createFileRoute("/beratung/$taxAdvisoryId/offenlegung")({
  loader: async ({
    context: { queryClient, trpc },
    params: { taxAdvisoryId },
  }) => {
    void queryClient.ensureQueryData(
      trpc.disclosureReviews.listOpenDisclosureReviews.queryOptions({
        taxAdvisoryId,
      })
    );
  },
  component: OffenlegungRoute,
});

function OffenlegungRoute() {
  const t = useTranslation(translations);
  const { taxAdvisoryId } = Route.useParams();
  const trpc = useTRPC();

  const { data: openDisclosures } = useQuery(
    trpc.disclosureReviews.listOpenDisclosureReviews.queryOptions({
      taxAdvisoryId,
    })
  );

  const disclosures = openDisclosures ?? [];

  return (
    <Page maxWidth={false}>
      <Container>
        <Typography variant="h3" component="h1" gutterBottom>
          {t("openDisclosuresHeading")}
        </Typography>

        {disclosures.length === 0 ? (
          <Paper sx={{ p: 3 }}>
            <Typography color="text.secondary">
              {t("noOpenDisclosures")}
            </Typography>
          </Paper>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("companyColumn")}</TableCell>
                  <TableCell>{t("yearColumn")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {disclosures.map((disclosure) => (
                  <TableRow key={`${disclosure.companyId}-${disclosure.year}`}>
                    <NavTableCell
                      to="/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung"
                      params={{
                        taxAdvisoryId,
                        companyId: disclosure.companyId,
                      }}
                      search={{ jahr: disclosure.year }}
                    >
                      {disclosure.companyName}
                    </NavTableCell>
                    <NavTableCell
                      to="/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung"
                      params={{
                        taxAdvisoryId,
                        companyId: disclosure.companyId,
                      }}
                      search={{ jahr: disclosure.year }}
                    >
                      {disclosure.year}
                    </NavTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
    </Page>
  );
}
